
      export type IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "UNION",
        "name": "AcknowledgeTripChangeProposalResult",
        "possibleTypes": [
          {
            "name": "AcknowledgeTripChangeProposalSuccess"
          },
          {
            "name": "AcknowledgeTripChangeProposalFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "Author",
        "possibleTypes": [
          {
            "name": "User"
          },
          {
            "name": "Driver"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CancelTripResult",
        "possibleTypes": [
          {
            "name": "Trip"
          },
          {
            "name": "CancelTripFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ChatParticipantUnion",
        "possibleTypes": [
          {
            "name": "Driver"
          },
          {
            "name": "Contact"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ContactsAndFarmAffiliatesAndCompanies",
        "possibleTypes": [
          {
            "name": "Contact"
          },
          {
            "name": "Company"
          },
          {
            "name": "MoovsNetworkOperator"
          },
          {
            "name": "GriddnetOperator"
          },
          {
            "name": "MoovsAiOperator"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CreateCancellationPolicyResult",
        "possibleTypes": [
          {
            "name": "CancellationPolicy"
          },
          {
            "name": "CreateCancellationPolicyFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CreateInstantPayoutResult",
        "possibleTypes": [
          {
            "name": "CreateInstantPayoutSuccess"
          },
          {
            "name": "CreateInstantPayoutFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CreateQrCodeResult",
        "possibleTypes": [
          {
            "name": "QRCode"
          },
          {
            "name": "CreateQrCodeFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CreateStripeExternalAccountResult",
        "possibleTypes": [
          {
            "name": "CreateStripeExternalAccountSuccess"
          },
          {
            "name": "CreateStripeExternalAccountFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CreateVehicleResult",
        "possibleTypes": [
          {
            "name": "Vehicle"
          },
          {
            "name": "CreateVehicleFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "DeleteQrCodeResult",
        "possibleTypes": [
          {
            "name": "QRCode"
          },
          {
            "name": "DeleteQrCodeFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "FarmAffiliate",
        "possibleTypes": [
          {
            "name": "ExternalOperator"
          },
          {
            "name": "MoovsNetworkOperator"
          },
          {
            "name": "GriddnetOperator"
          },
          {
            "name": "MoovsAiOperator"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "InstallMoovsMarketAppResult",
        "possibleTypes": [
          {
            "name": "MoovsMarketApps"
          },
          {
            "name": "InstallMoovsMarketAppFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "MetadataUnion",
        "possibleTypes": [
          {
            "name": "TripChangeMetadata"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "MoovsTransaction",
        "possibleTypes": [
          {
            "name": "Payment"
          },
          {
            "name": "PaymentRefund"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Node",
        "possibleTypes": [
          {
            "name": "Billing"
          },
          {
            "name": "CancellationPolicy"
          },
          {
            "name": "Comment"
          },
          {
            "name": "Company"
          },
          {
            "name": "Contact"
          },
          {
            "name": "Driver"
          },
          {
            "name": "DriverAvailability"
          },
          {
            "name": "DynamicPricingRule"
          },
          {
            "name": "EmailLog"
          },
          {
            "name": "ExternalOperator"
          },
          {
            "name": "GriddnetOperator"
          },
          {
            "name": "InsurancePolicy"
          },
          {
            "name": "Invoice"
          },
          {
            "name": "MoovsAiOperator"
          },
          {
            "name": "MoovsNetworkOperator"
          },
          {
            "name": "Operator"
          },
          {
            "name": "OperatorRoute"
          },
          {
            "name": "Payment"
          },
          {
            "name": "PaymentMethod"
          },
          {
            "name": "PaymentRefund"
          },
          {
            "name": "PriceZone"
          },
          {
            "name": "PriceZoneRoute"
          },
          {
            "name": "PriceZoneRouteVehicle"
          },
          {
            "name": "Request"
          },
          {
            "name": "Route"
          },
          {
            "name": "ShuttleRoute"
          },
          {
            "name": "Stop"
          },
          {
            "name": "SubPayment"
          },
          {
            "name": "SubRefund"
          },
          {
            "name": "TeamMember"
          },
          {
            "name": "Term"
          },
          {
            "name": "TermType"
          },
          {
            "name": "TrackedFlight"
          },
          {
            "name": "Transaction"
          },
          {
            "name": "Trip"
          },
          {
            "name": "User"
          },
          {
            "name": "UserAccessPermission"
          },
          {
            "name": "Vehicle"
          },
          {
            "name": "VehicleChildSeat"
          },
          {
            "name": "VehicleFeature"
          },
          {
            "name": "VehiclePhoto"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "PaymentMethodTransaction",
        "possibleTypes": [
          {
            "name": "Payment"
          },
          {
            "name": "PaymentRefund"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "RemoveStripeBankAccountResult",
        "possibleTypes": [
          {
            "name": "RemoveStripeBankAccountSuccess"
          },
          {
            "name": "RemoveStripeBankAccountFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ResendInviteResult",
        "possibleTypes": [
          {
            "name": "ResendInviteSuccess"
          },
          {
            "name": "ResendInviteFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SearchResult",
        "possibleTypes": [
          {
            "name": "Driver"
          },
          {
            "name": "Request"
          },
          {
            "name": "Contact"
          },
          {
            "name": "Company"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SendDriverAssignTextOrNotificationResult",
        "possibleTypes": [
          {
            "name": "SendDriverAssignTextOrNotificationSuccess"
          },
          {
            "name": "SendDriverAssignTextOrNotificationFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SendEmailToMultipleCustomersResult",
        "possibleTypes": [
          {
            "name": "SendEmailToMultipleCustomersSuccess"
          },
          {
            "name": "SendEmailToMultipleCustomersFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SubscribeToCrmResult",
        "possibleTypes": [
          {
            "name": "SubscribeToCrmSuccess"
          },
          {
            "name": "SubscribeToCrmFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "UpdateBulkRouteDispatchResult",
        "possibleTypes": [
          {
            "name": "UpdateBulkRouteDispatchSuccess"
          },
          {
            "name": "UpdateBulkRouteDispatchFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "UpdateDefaultBankAccountResult",
        "possibleTypes": [
          {
            "name": "UpdateDefaultBankAccountSuccess"
          },
          {
            "name": "UpdateDefaultBankAccountFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "UpdateNotificationSettingResult",
        "possibleTypes": [
          {
            "name": "NotificationSetting"
          },
          {
            "name": "UpdateNotificationSettingFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "UpdateVehicleResult",
        "possibleTypes": [
          {
            "name": "Vehicle"
          },
          {
            "name": "UpdateVehicleFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ZoneVariantData",
        "possibleTypes": [
          {
            "name": "ZipCodeZone"
          },
          {
            "name": "LocationZone"
          }
        ]
      }
    ]
  }
};
      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "UNION",
        "name": "AcknowledgeTripChangeProposalResult",
        "possibleTypes": [
          {
            "name": "AcknowledgeTripChangeProposalSuccess"
          },
          {
            "name": "AcknowledgeTripChangeProposalFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "Author",
        "possibleTypes": [
          {
            "name": "User"
          },
          {
            "name": "Driver"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CancelTripResult",
        "possibleTypes": [
          {
            "name": "Trip"
          },
          {
            "name": "CancelTripFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ChatParticipantUnion",
        "possibleTypes": [
          {
            "name": "Driver"
          },
          {
            "name": "Contact"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ContactsAndFarmAffiliatesAndCompanies",
        "possibleTypes": [
          {
            "name": "Contact"
          },
          {
            "name": "Company"
          },
          {
            "name": "MoovsNetworkOperator"
          },
          {
            "name": "GriddnetOperator"
          },
          {
            "name": "MoovsAiOperator"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CreateCancellationPolicyResult",
        "possibleTypes": [
          {
            "name": "CancellationPolicy"
          },
          {
            "name": "CreateCancellationPolicyFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CreateInstantPayoutResult",
        "possibleTypes": [
          {
            "name": "CreateInstantPayoutSuccess"
          },
          {
            "name": "CreateInstantPayoutFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CreateQrCodeResult",
        "possibleTypes": [
          {
            "name": "QRCode"
          },
          {
            "name": "CreateQrCodeFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CreateStripeExternalAccountResult",
        "possibleTypes": [
          {
            "name": "CreateStripeExternalAccountSuccess"
          },
          {
            "name": "CreateStripeExternalAccountFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CreateVehicleResult",
        "possibleTypes": [
          {
            "name": "Vehicle"
          },
          {
            "name": "CreateVehicleFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "DeleteQrCodeResult",
        "possibleTypes": [
          {
            "name": "QRCode"
          },
          {
            "name": "DeleteQrCodeFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "FarmAffiliate",
        "possibleTypes": [
          {
            "name": "ExternalOperator"
          },
          {
            "name": "MoovsNetworkOperator"
          },
          {
            "name": "GriddnetOperator"
          },
          {
            "name": "MoovsAiOperator"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "InstallMoovsMarketAppResult",
        "possibleTypes": [
          {
            "name": "MoovsMarketApps"
          },
          {
            "name": "InstallMoovsMarketAppFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "MetadataUnion",
        "possibleTypes": [
          {
            "name": "TripChangeMetadata"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "MoovsTransaction",
        "possibleTypes": [
          {
            "name": "Payment"
          },
          {
            "name": "PaymentRefund"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Node",
        "possibleTypes": [
          {
            "name": "Billing"
          },
          {
            "name": "CancellationPolicy"
          },
          {
            "name": "Comment"
          },
          {
            "name": "Company"
          },
          {
            "name": "Contact"
          },
          {
            "name": "Driver"
          },
          {
            "name": "DriverAvailability"
          },
          {
            "name": "DynamicPricingRule"
          },
          {
            "name": "EmailLog"
          },
          {
            "name": "ExternalOperator"
          },
          {
            "name": "GriddnetOperator"
          },
          {
            "name": "InsurancePolicy"
          },
          {
            "name": "Invoice"
          },
          {
            "name": "MoovsAiOperator"
          },
          {
            "name": "MoovsNetworkOperator"
          },
          {
            "name": "Operator"
          },
          {
            "name": "OperatorRoute"
          },
          {
            "name": "Payment"
          },
          {
            "name": "PaymentMethod"
          },
          {
            "name": "PaymentRefund"
          },
          {
            "name": "PriceZone"
          },
          {
            "name": "PriceZoneRoute"
          },
          {
            "name": "PriceZoneRouteVehicle"
          },
          {
            "name": "Request"
          },
          {
            "name": "Route"
          },
          {
            "name": "ShuttleRoute"
          },
          {
            "name": "Stop"
          },
          {
            "name": "SubPayment"
          },
          {
            "name": "SubRefund"
          },
          {
            "name": "TeamMember"
          },
          {
            "name": "Term"
          },
          {
            "name": "TermType"
          },
          {
            "name": "TrackedFlight"
          },
          {
            "name": "Transaction"
          },
          {
            "name": "Trip"
          },
          {
            "name": "User"
          },
          {
            "name": "UserAccessPermission"
          },
          {
            "name": "Vehicle"
          },
          {
            "name": "VehicleChildSeat"
          },
          {
            "name": "VehicleFeature"
          },
          {
            "name": "VehiclePhoto"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "PaymentMethodTransaction",
        "possibleTypes": [
          {
            "name": "Payment"
          },
          {
            "name": "PaymentRefund"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "RemoveStripeBankAccountResult",
        "possibleTypes": [
          {
            "name": "RemoveStripeBankAccountSuccess"
          },
          {
            "name": "RemoveStripeBankAccountFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ResendInviteResult",
        "possibleTypes": [
          {
            "name": "ResendInviteSuccess"
          },
          {
            "name": "ResendInviteFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SearchResult",
        "possibleTypes": [
          {
            "name": "Driver"
          },
          {
            "name": "Request"
          },
          {
            "name": "Contact"
          },
          {
            "name": "Company"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SendDriverAssignTextOrNotificationResult",
        "possibleTypes": [
          {
            "name": "SendDriverAssignTextOrNotificationSuccess"
          },
          {
            "name": "SendDriverAssignTextOrNotificationFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SendEmailToMultipleCustomersResult",
        "possibleTypes": [
          {
            "name": "SendEmailToMultipleCustomersSuccess"
          },
          {
            "name": "SendEmailToMultipleCustomersFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SubscribeToCrmResult",
        "possibleTypes": [
          {
            "name": "SubscribeToCrmSuccess"
          },
          {
            "name": "SubscribeToCrmFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "UpdateBulkRouteDispatchResult",
        "possibleTypes": [
          {
            "name": "UpdateBulkRouteDispatchSuccess"
          },
          {
            "name": "UpdateBulkRouteDispatchFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "UpdateDefaultBankAccountResult",
        "possibleTypes": [
          {
            "name": "UpdateDefaultBankAccountSuccess"
          },
          {
            "name": "UpdateDefaultBankAccountFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "UpdateNotificationSettingResult",
        "possibleTypes": [
          {
            "name": "NotificationSetting"
          },
          {
            "name": "UpdateNotificationSettingFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "UpdateVehicleResult",
        "possibleTypes": [
          {
            "name": "Vehicle"
          },
          {
            "name": "UpdateVehicleFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ZoneVariantData",
        "possibleTypes": [
          {
            "name": "ZipCodeZone"
          },
          {
            "name": "LocationZone"
          }
        ]
      }
    ]
  }
};
      export default result;
    